export default __webpack_public_path__ + "static/media/banner8.c2fcd440.JPG";